'use client';

import { FC, PropsWithChildren } from 'react';
import Toaster from '../Toaster/Toaster';
import styles from './styles.module.scss';

const NotifsLayer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      {children}
      <div className={styles['container']}>
        <Toaster />
      </div>
    </>
  );
};

export default NotifsLayer;
